import {
  Autocomplete,
  Backdrop,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  capitalizeWords,
  DDMMYYYY_formate,
  decryptedAdminID,
  DMMMYYYY_formate,
  interviewStatusOptions,
  MyModal,
  textTruncate,
} from "../../utility";
import ModalContainer from "../../components/modal_popup";
import { AiFillFilter, AiOutlineClose, AiOutlineFilter } from "react-icons/ai";
import {
  GetAllAdminDetails,
  getcandidateDetails,
  getCandidateLead,
  GetTeamMemeberEvent,
} from "../../apiServices";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import { commonPopupActions } from "../../redux-store/store";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#d2d2d2",
    color: "#545454f0",
    padding: "8px",
    "@media (max-width: 992px)": {},
  },
  [`&.${tableCellClasses.body}`]: {
    padding: "8px",
    fontSize: 14,
    "@media (max-width: 992px)": {},
  },
}));

const extractCompanyName = (description) => {
  if (!description) {
    console.error("Description is null or undefined");
    return "";
  }
  // Extract the JSON part of the description
  const jsonPart = description.match(/{.*}/);

  if (jsonPart) {
    try {
      // Parse the JSON
      const data = JSON.parse(jsonPart[0]);
      return data.companyName || "";
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return "";
    }
  }

  return "";
};
const TeamMemberActionTable = ({ onClose }) => {
  //   const
  const [showLoader, setShowLoader] = useState(false);
  const [showEvent, setShowEvent] = useState(false);
  const [fullDescription, setFullDescription] = useState();
  const [openFilter, setOpenFilter] = useState(false);
  const initialState = {
    page: 1,
    size: 10,
    adminId: decryptedAdminID(),
    eventName: "",
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    myTeam: true,
    dateFilterType: "Today",
  };
  const [filterData, setFilterData] = useState({
    page: 1,
    size: 10,
    adminId: decryptedAdminID(),
    eventName: "",
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    myTeam: true,
    dateFilterType: "Today",
  });
  const [redDot, setRedDot] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [eventList, seteventList] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showCustom, setshowCustom] = useState(false);
  const Dispatch = useDispatch();
  const [pageCount, setPageCount] = useState({
    totalCount: 1,
    totalRecords: 0,
  });

  const open = Boolean(anchorEl);
  const handleDateClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [dateRange, setDateRange] = useState({
    start: filterData.startDate,
    end: filterData.endDate,
    dateFilterType: filterData.dateFilterType,
  });

  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });
  useEffect(() => {
    const teamLeaderId = localStorage.getItem("teamLeaderId");
    const teamLeader = localStorage.getItem("teamLeader");
    GetAllAdminDetails().then((data) => {
      const withoutleaderID = teamLeaderId;
      const withoutleader = teamLeader;
      const activeAdmins = data.filter((item) =>
        !item.Deactived &&
        item.Module !== "Developer" &&
        withoutleader == "true"
          ? item.id != withoutleaderID
          : item.id
      );
      setAdminList(activeAdmins);
    });
  }, []);
  const handleAssignToChange = (selectedValue) => {
    console.log("Selected Value:", selectedValue);

    if (selectedValue === "myTeam") {
      const assignTo = parseInt(decryptedAdminID());

      setFilterData((prev) => ({
        ...prev,
        myTeam: true,
        adminId: assignTo,
      }));
    } else {
      setFilterData((prev) => ({
        ...prev,
        myTeam: false,
        adminId: selectedValue,
      }));
    }
  };
  const handleDateSelect = (val) => {
    let selectedOption = val;
    const today = new Date();
    let endDate = new Date();
    if (selectedOption === "today") {
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Today",
        start: today.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
      setAnchorEl(null);
    } else if (selectedOption === "lastMonth") {
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1);

      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Last Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
      setAnchorEl(null);
    } else if (selectedOption === "yesterday") {
      const startDate = new Date();
      const endDate = new Date();
      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() - 1);

      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Yesterday",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
      setAnchorEl(null);
    } else if (selectedOption === "custom") {
      setshowCustom(true);
      setAnchorEl(null);
    }
  };
  function handleCustomDate(value, type) {
    const val = value.target.value;

    if (type === "startDate") {
      setDateRange((prev) => ({
        ...prev,
        start: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        end: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  }
  const isFormValid = () => {
    // Implement your validation logic here
    // For example, you can check if both start and end dates are filled
    const isValid = dateRange.start && dateRange.end;

    if (!dateRange.start) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!dateRange.end) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };
  const handleApplyDate = (e) => {
    e.preventDefault();

    if (isFormValid()) {
      // Your submit logic here
      // Proceed with form submission

      setValidationErrors({
        start: false,
        end: false,
      });
      setshowCustom(false); // Close the modal or perform other actions
    }
  };
  const handleCandidateDetails = async (candidateId, type) => {
    let data;
    if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateId);
    } else if (type === "CandidateLead") {
      data = await getCandidateLead(candidateId);
    }

    // Dispatch action to show the popup and pass the fetched data
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateId,
        type: type,
        data: data,
      })
    );
  };
  useEffect(() => {
    const debounceData = debounce(() => {
      GetTeamMemeberEvent(filterData).then((data) => {
        seteventList(data.data);
        setPageCount((prev) => ({
          ...prev,
          totalCount: data.pagination.totalPages,
          totalRecords: data.pagination.totalRecords,
        }));
        setShowLoader(false);
      });
    }, 300);

    if (filterData.startDate && filterData.endDate) {
      setShowLoader(true);
      debounceData();
    }

    return () => {
      debounceData.cancel();
    };
  }, [filterData]);

  function handleSubmit(e) {
    if (
      JSON.stringify(initialState) !==
      (JSON.stringify(filterData) || JSON.stringify(dateRange))
    ) {
      setRedDot(true);
      console.log("ggddg");
    } else {
      console.log("ggg");

      setRedDot(false);
    }
    e.preventDefault();
    setOpenFilter(false);
    setShowLoader(true);

    setFilterData((prev) => ({
      ...prev,
      startDate: dateRange.start,
      endDate: dateRange.end,
      eventName: prev.eventName,
    }));
  }

  const handleClearAll = (e) => {
    e.preventDefault();
    const today = new Date().toISOString().split("T")[0];
    setDateRange({
      start: today,
      end: today,
      dateFilterType: "Today",
    });
    setFilterData({
      page: 1,
      size: 10,
      adminId: decryptedAdminID(),
      eventName: "",
      startDate: "",
      endDate: "",
      myTeam: true,
      dateFilterType: "Today",
    });
    // setFilterData((prev) => ({
    //   ...prev,
    //   eventName: "",
    //   startDate: today,
    //   endDate: today,
    //   dateFilterType: "Today",
    // }));
    setRedDot(false);
  };

  //   console.log(pageCount.totalCount);

  function candidatePagination(event, page) {
    const currentPage = page;

    setFilterData((prev) => ({
      ...prev,
      page: currentPage,
    }));
  }

  const modifyEventDescription = (description) => {
    if (!description) {
      console.error("Description is null or undefined");
      return "";
    }
    const companyName = extractCompanyName(description);
    const regex = /{.*?}/;
    return description.replace(regex, companyName);
  };
  return (
    <div>
      {" "}
      <div>
        <div className="d-flex align-item-center justify-content-between">
          <div>
            <b>My Team Actions</b>
          </div>
          <div className="d-flex  gap-2">
            <div>
              <button
                className="btn btn-success d-flex align-items-center"
                onClick={() => {
                  setOpenFilter(true);
                }}
              >
                <AiOutlineFilter />
                <p
                  style={{
                    backgroundColor: redDot ? "red" : "transparent",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                ></p>
                Filter
              </button>
            </div>
            <div className="btn btn-danger" onClick={onClose}>
              <AiOutlineClose />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center ">
          <div>
            Total Count: <b>{pageCount.totalRecords}</b>
          </div>
        </div>

        {openFilter && (
          <>
            <MyModal>
              <ModalContainer
                childComponent={
                  <>
                    <div style={{ width: "300px" }}>
                      <div className="d-flex align-item-center justify-content-between mb-2">
                        <div>
                          <b>Filter</b>
                        </div>
                        <div
                          className="btn btn-danger"
                          onClick={() => {
                            setOpenFilter(false);
                          }}
                        >
                          <AiOutlineClose />
                        </div>
                      </div>
                      <div>
                        <div>
                          <div>
                            <Autocomplete
                              options={[
                                { label: "My team", value: "myTeam" },
                                { label: "Only for me", value: "-1" },
                                ...adminList.map((el) => ({
                                  label: el.userName, // Show username in UI
                                  value: el.id, // Pass ID on selection
                                })),
                              ]}
                              getOptionLabel={(option) => option?.label || ""} // Ensure it doesn't break if option is null
                              value={
                                filterData.myTeam
                                  ? { label: "My team", value: "myTeam" }
                                  : adminList.find(
                                      (el) => el.id === filterData.adminId
                                    )
                                  ? {
                                      label: adminList.find(
                                        (el) => el.id === filterData.adminId
                                      ).userName,
                                      value: filterData.adminId,
                                    }
                                  : {
                                      label: "Only for me",
                                      value: decryptedAdminID(),
                                    }
                              }
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  handleAssignToChange(newValue.value);
                                } else {
                                  handleAssignToChange(null);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Team Member"
                                  className="form-control"
                                />
                              )}
                            />
                          </div>
                          <div className="mt-2">
                            <FormControl variant="outlined" fullWidth>
                              <TextField
                                label="Event on"
                                id="basic-button"
                                value={`${dateRange.dateFilterType}`}
                                // value={`${dateRange.start} - ${dateRange.end}`}
                                aria-controls={open ? "basic-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                onClick={handleDateClick}
                              ></TextField>
                              <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                  "aria-labelledby": "basic-button",
                                }}
                              >
                                <MenuItem
                                  onClick={() => {
                                    handleDateSelect("today");
                                  }}
                                  style={{ width: "210px" }}
                                >
                                  Today
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    handleDateSelect("yesterday");
                                  }}
                                >
                                  Yesterday
                                </MenuItem>

                                <MenuItem
                                  onClick={() => {
                                    handleDateSelect("custom");
                                  }}
                                >
                                  Custom Date
                                </MenuItem>
                              </Menu>
                            </FormControl>
                            {/*  */}
                            {showCustom && (
                              <MyModal>
                                <ModalContainer
                                  zIndex={1005}
                                  childComponent={
                                    <div
                                      style={{
                                        minWidth: "400px",
                                        width: "auto",
                                      }}
                                    >
                                      <>
                                        <div>
                                          <form>
                                            <p className="text-center ">
                                              Select Custom Date{" "}
                                            </p>
                                            <div className="mt-2">
                                              <label htmlFor="start">
                                                From
                                              </label>
                                              <input
                                                className={`form-control ${
                                                  validationErrors.start
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                //   value={filterData.startDate}
                                                style={{ width: "100%" }}
                                                type="date"
                                                id="start"
                                                onChange={(value) =>
                                                  handleCustomDate(
                                                    value,
                                                    "startDate"
                                                  )
                                                }
                                                name="trip-start"
                                                min="2020-01-01"
                                                max={
                                                  new Date()
                                                    .toISOString()
                                                    .split("T")[0]
                                                }
                                              />
                                              {validationErrors.start && (
                                                <div className="invalid-feedback">
                                                  Start date is required.
                                                </div>
                                              )}
                                            </div>
                                            <div className="mt-2">
                                              <label htmlFor="end">To</label>
                                              <input
                                                className={`form-control ${
                                                  validationErrors.end
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                //   value={filterData.endDate}
                                                style={{ width: "100%" }}
                                                type="date"
                                                id="end"
                                                onChange={(value) =>
                                                  handleCustomDate(
                                                    value,
                                                    "endDate"
                                                  )
                                                }
                                                name="trip-end"
                                                min="2020-01-01"
                                                max={
                                                  new Date()
                                                    .toISOString()
                                                    .split("T")[0]
                                                }
                                              />
                                              {validationErrors.end && (
                                                <div className="invalid-feedback">
                                                  End date is required.
                                                </div>
                                              )}
                                            </div>
                                            <div className="d-flex justify-content-end mt-3 ">
                                              <button
                                                onClick={() => {
                                                  setValidationErrors({
                                                    start: false,
                                                    end: false,
                                                  });
                                                  setshowCustom(false);
                                                }}
                                                style={{
                                                  backgroundColor: "#b2261c",
                                                }}
                                                className="btn rounded-pill text-white px-4  me-2"
                                              >
                                                Close
                                              </button>
                                              <button
                                                onClick={handleApplyDate}
                                                // color="primary"
                                                className="btn rounded-pill text-white px-4"
                                                style={{
                                                  backgroundColor: "#169C50",
                                                }}
                                              >
                                                Apply
                                              </button>
                                            </div>
                                          </form>
                                        </div>
                                      </>
                                    </div>
                                  }
                                />
                              </MyModal>
                            )}
                          </div>
                          <div className="mt-2">
                            <Autocomplete
                              options={interviewStatusOptions}
                              getOptionLabel={(option) => option.label}
                              value={
                                interviewStatusOptions.find(
                                  (opt) => opt.value === filterData.eventName
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                setFilterData((prev) => ({
                                  ...prev,
                                  eventName: newValue ? newValue.value : null,
                                }));
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Event Name"
                                  variant="outlined"
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="d-flex align-item-center justify-content-end gap-2 mt-2">
                          <button
                            className="btn btn-danger"
                            onClick={handleClearAll}
                          >
                            Clear
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success"
                            onClick={handleSubmit}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
              />
            </MyModal>
          </>
        )}
      </div>
      <div className="mt-2">
        <TableContainer style={{ height: "64vh", overflowY: "auto" }}>
          <Table stickyHeader aria-label="sticky table" className={``}>
            <TableHead>
              <TableRow>
                <StyledTableCell>Candidate Name</StyledTableCell>
                <StyledTableCell>Event Name</StyledTableCell>
                <StyledTableCell>Event Description</StyledTableCell>
                <StyledTableCell>Recruiter Name</StyledTableCell>
                <StyledTableCell>Event on</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {eventList.length > 0 ? (
                eventList.map((data, i) => {
                  const modifiedDescription = modifyEventDescription(
                    data.event_description
                  );

                  return (
                    <TableRow
                      key={i}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <StyledTableCell>
                        <span
                          onClick={() => {
                            handleCandidateDetails(
                              data.can_id,
                              "RegisterCandidate"
                            );
                          }}
                          style={{ cursor: "pointer" }}
                          className="text-primary"
                          title={data.first_name}
                        >
                          {data.first_name
                            ? textTruncate(
                                capitalizeWords(data.first_name),
                                15
                              ) +
                              " " +
                              (data.last_name
                                ? textTruncate(
                                    capitalizeWords(data.last_name),
                                    15
                                  )
                                : "")
                            : "-"}
                        </span>
                      </StyledTableCell>
                      <StyledTableCell title={data.event_name}>
                        {data.event_name
                          ? textTruncate(capitalizeWords(data.event_name), 25)
                          : "-"}
                      </StyledTableCell>
                      <StyledTableCell
                        onClick={() => {
                          setShowEvent(true);
                          setFullDescription(modifiedDescription);
                        }}
                        title={modifiedDescription}
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        {textTruncate(capitalizeWords(modifiedDescription), 15)}
                      </StyledTableCell>
                      <StyledTableCell title={data.admin_name}>
                        {data.admin_name
                          ? textTruncate(capitalizeWords(data.admin_name), 15)
                          : "-"}
                      </StyledTableCell>
                      <StyledTableCell>
                        <DDMMYYYY_formate dateValue={data.created_time} />
                      </StyledTableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },  
                  }}
                >
                  <StyledTableCell colSpan={5} align="center">
                    <Typography
                      variant="body1"
                      color="error"
                      sx={{ margin: 3 }}
                    >
                      <b>Data Not Found</b>
                    </Typography>
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={showLoader}
            onClick={() => {}} // Prevent closing on backdrop click
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
        {showEvent && (
          <>
            <MyModal>
              <ModalContainer
                childComponent={
                  <>
                    <div style={{ width: "450px" }}>
                      <div>
                        <div className="d-flex justify-content-between align-items-center ">
                          <div>
                            <b>Event Description</b>
                          </div>
                          <div
                            onClick={() => {
                              setShowEvent(false);
                            }}
                            className="btn btn-danger mb-1"
                          >
                            <AiOutlineClose />
                          </div>
                        </div>
                        <div>{fullDescription}</div>
                      </div>
                    </div>
                  </>
                }
              />
            </MyModal>
          </>
        )}
        <div className="d-flex justify-content-center mt-2">
          <Stack spacing={2}>
            <Pagination
              count={pageCount?.totalCount || 1}
              shape="rounded"
              siblingCount={1}
              boundaryCount={1}
              variant="outlined"
              color="success"
              onChange={candidatePagination}
            />
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberActionTable;
